import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import {
  AddToJobCandidate,
  AddToJobDrawerContent
} from 'modules/ats/components/AddToJob/AddToJobDrawerContent';

type OpenAddToJobDrawerProps = {
  organizationId: string;
  candidates: AddToJobCandidate[];
  initialAtsJobId?: string | null;
};

export const useAddToJobDrawer = () => {
  const { openDrawer } = useDrawerV2();

  const openAddToJobDrawer = ({
    organizationId,
    candidates,
    initialAtsJobId
  }: OpenAddToJobDrawerProps) => {
    openDrawer({
      title: 'Add to job',
      width: '700px',
      children: (
        <AddToJobDrawerContent
          organizationId={organizationId}
          candidates={candidates}
          initialAtsJobId={initialAtsJobId}
        />
      )
    });
  };

  return { openAddToJobDrawer };
};
